export default __webpack_public_path__ + "static/media/mosaic-logo-full-white.26d454d6.svg";